// extracted by mini-css-extract-plugin
export var borderRadius = "_5b-4";
export var large = "_5b-3";
export var logoContainer = "_5b-0";
export var nameLogo = "_5b-2";
export var small = "_5b-1";